import { openBlock as _, createElementBlock as k, createElementVNode as i, toDisplayString as u, ref as c, resolveComponent as f, withModifiers as m, normalizeClass as p, createVNode as r } from "vue";
import { _ as d, N as $ } from "./index-B_KFPBbP.mjs";
const g = {
  name: "NaviMetaEntry",
  props: {
    text: String,
    href: String
  }
}, C = { class: "km__list__element--unterkategorie" }, N = { class: "km__list__element--unterkategorie--text" }, x = ["href"], P = {
  key: 1,
  href: "#"
};
function y(n, e, l, t, v, a) {
  return _(), k("li", C, [
    i("div", N, [
      l.href !== void 0 ? (_(), k("a", {
        key: 0,
        href: l.href,
        target: "_blank"
      }, u(l.text), 9, x)) : (_(), k("a", P, u(l.text), 1))
    ])
  ]);
}
const M = /* @__PURE__ */ d(g, [["render", y]]), T = {
  name: "ModuleNaviMeta",
  components: {
    NaviMetaEntry: M
  },
  emits: ["openPopup", "close_menu"],
  setup(n, e) {
    const l = c();
    function t(a) {
      l.value === a ? l.value = "" : l.value = a;
    }
    function v(a) {
      $.CLOSE_NAVI(), e.emit("openPopup", a);
    }
    return {
      currentCat: l,
      openPopup: v,
      setActive: t
    };
  }
}, b = { class: "km__navi--content-wrapper" }, w = { class: "km__list--modules" }, E = { class: "km__list--modules--unterkategorie" }, S = { class: "km__list--modules--unterkategorie" }, z = { class: "km__navi--close-wrapper" };
function A(n, e, l, t, v, a) {
  const s = f("NaviMetaEntry");
  return _(), k("div", {
    class: "km__navi--meta",
    onClick: e[11] || (e[11] = m((o) => n.$emit("close_menu"), ["self"]))
  }, [
    i("div", b, [
      i("ul", w, [
        i("li", {
          class: p(["km__navi__element--oberkategorie", { active: t.currentCat === 1 }])
        }, [
          i("div", {
            class: "km__navi__element--oberkategorie--text",
            onClick: e[0] || (e[0] = (o) => t.setActive(1))
          }, u(n.$t("service_neuHauptNaviTitle")), 1),
          i("ul", E, [
            r(s, {
              text: n.$t("konf_designcheck_header"),
              onClick: e[1] || (e[1] = (o) => t.openPopup("designcheck"))
            }, null, 8, ["text"]),
            r(s, {
              text: n.$t("konf_designwuensche_header"),
              onClick: e[2] || (e[2] = (o) => t.openPopup("designwish"))
            }, null, 8, ["text"]),
            r(s, {
              text: n.$t("konf_contactOwayo_MusterTitle"),
              onClick: e[3] || (e[3] = (o) => t.openPopup("musterservice"))
            }, null, 8, ["text"]),
            r(s, {
              text: n.$t("konf_contactOwayo_KostenvoranschlagTitle"),
              onClick: e[4] || (e[4] = (o) => t.openPopup("angebotsservice"))
            }, null, 8, ["text"]),
            r(s, {
              text: n.$t("konf_sizesInformationTitle"),
              onClick: e[5] || (e[5] = (o) => t.openPopup("productsize"))
            }, null, 8, ["text"]),
            r(s, {
              text: n.$t("konf_lieferzeiten_erklaerungTitle"),
              onClick: e[6] || (e[6] = (o) => t.openPopup("deliverytime"))
            }, null, 8, ["text"])
          ])
        ], 2),
        i("li", {
          class: p(["km__navi__element--oberkategorie", { active: t.currentCat === 2 }])
        }, [
          i("div", {
            class: "km__navi__element--oberkategorie--text",
            onClick: e[7] || (e[7] = (o) => t.setActive(2))
          }, u(n.$t("kontaktHauptNaviTitle")), 1),
          i("ul", S, [
            r(s, {
              text: n.$t("kontaktHauptNaviTitle"),
              onClick: e[8] || (e[8] = (o) => t.openPopup("contact"))
            }, null, 8, ["text"]),
            r(s, {
              text: n.$t("kontaktformular_neuHauptNaviTitle"),
              onClick: e[9] || (e[9] = (o) => t.openPopup("contactform"))
            }, null, 8, ["text"])
          ])
        ], 2)
      ])
    ]),
    i("div", z, [
      i("div", {
        class: "km__navi--close",
        onClick: e[10] || (e[10] = m((o) => n.$emit("close_menu"), ["self"]))
      })
    ])
  ]);
}
const I = /* @__PURE__ */ d(T, [["render", A], ["__scopeId", "data-v-931bc3d8"]]);
export {
  I as default
};
